import React from 'react'

// apollo
import { ApolloProvider } from '@apollo/client'
import { client } from 'lib/apollo'

// redux
import { Provider as ReduxProvider } from 'react-redux'
import store from 'lib/stores/login/redux'

// shared components
import AppErrorBoundary from 'components/shared/AppErrorBoundary'
import BrandTheme from 'components/shared/BrandTheme'
import SettingsProvider from 'components/shared/SettingsProvider'
import CssBaseline from '@mui/material/CssBaseline'

// local components
import Routes from './Routes'

// date picker
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'

const App = props => {
  const {
    basename,
    appSettings,
    brandSettings,
    headerMessage,
    notice,
    bhParam,
  } = props

  return (
    <SettingsProvider appSettings={appSettings} brandSettings={brandSettings}>
      <ReduxProvider store={store}>
        <ApolloProvider client={client}>
          <LocalizationProvider dateAdapter={AdapterMoment}>
            <BrandTheme brandSettings={brandSettings}>
              <CssBaseline />
              <AppErrorBoundary>
                <Routes
                  basename={basename}
                  headerMessage={headerMessage}
                  notice={notice}
                  bhParam={bhParam}
                />
              </AppErrorBoundary>
            </BrandTheme>
          </LocalizationProvider>
        </ApolloProvider>
      </ReduxProvider>
    </SettingsProvider>
  )
}

export default App
